import { Badge } from '@chakra-ui/react'

export type StatusVariant = 'success' | 'warning' | 'danger' | 'info' | 'neutral'

interface StatusChipProps {
  variant: StatusVariant
  children: React.ReactNode
}

// Tint bg + matching fg, straight from the slice-1 semantic tokens. This is the
// app's entire status vocabulary (spec §6.1). Accent is never used here — status
// is tint-only, accent is fill-only.
const TOKENS: Record<StatusVariant, { bg: string; fg: string }> = {
  success: { bg: 'success.subtle', fg: 'success.fg' },
  warning: { bg: 'warning.subtle', fg: 'warning.fg' },
  danger: { bg: 'danger.subtle', fg: 'danger.fg' },
  info: { bg: 'info.subtle', fg: 'info.fg' },
  neutral: { bg: 'surface.2', fg: 'ink.2' },
}

export function StatusChip({ variant, children }: StatusChipProps) {
  const t = TOKENS[variant]
  return (
    <Badge bg={t.bg} color={t.fg} data-status={variant}>
      {children}
    </Badge>
  )
}
